export enum URLType {
  None = 0,
  JavaScript = 1,
  IFrame = 2,
  ImagePixel = 3
}
